<template>
  <t-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
    :footer="false"
  >
    <form class="t-walkthrough-business-hours-date-time__form" @submit.prevent="handleSubmitForm">
      <div class="t-walkthrough-business-hours-date-time__description">
        <a-heading tag="h3" size="small">1. 営業時間設定</a-heading>
        <a-text>
          設定すると、時間外の着信は通知されなくなります。<br />
          時間外の設定は次のステップで行えます。
        </a-text>
      </div>
      <div class="t-walkthrough-business-hours-date-time__fields">
        <o-business-hour-setting-list v-model="currentPeriodList" />
      </div>
      <!--      <div class="t-walkthrough-business-hours-date-time__remark">-->
      <!--        <a-caption-list>-->
      <!--          <li>特定の日の留守電設定は、ホーム画面 ＞ 留守電自動切替設定 から行えます</li>-->
      <!--        </a-caption-list>-->
      <!--      </div>-->
      <div class="t-walkthrough-business-hours-date-time__buttons">
        <m-button-container>
          <a-button variant="block" submit="submit" color="primary">次へ</a-button>
          <a-button variant="outlined" color="primary" @click="handleCancelClick">戻る</a-button>
          <a-button
            color="primary"
            class="t-walkthrough-business-hours-date-time__button-optional"
            @click="handleNotSettingClick"
            >初期設定はせずにホーム画面へ</a-button
          >
        </m-button-container>
      </div>
    </form>
    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="walkthroughBusinessHours_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
    </teleport>
  </t-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TDefaultEntrySidebar from '@/components/templates/default-entry-sidebar';
import AHeading from '@/components/atoms/heading';
import ACaptionList from '@/components/atoms/caption-list';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MButtonContainer from '@/components/molecules/button-container';
import OBusinessHourSettingList from '@/components/organisms/business-hour-setting-list';
import { cloneDeep } from 'lodash';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';

export default {
  name: 't-walkthrough-business-hours-date-time',
  components: {
    TDefaultEntrySidebar,
    //ACaptionList,
    AHeading,
    AButton,
    AText,
    MButtonContainer,
    OBusinessHourSettingList,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    // handleFormSubmit: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleNotSettingClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      selectedCompanyID: '',
      currentPeriodList: [
        { label: '月曜日', active: false, is24hours: false, periods: [] },
        { label: '火曜日', active: false, is24hours: false, periods: [] },
        { label: '水曜日', active: false, is24hours: false, periods: [] },
        { label: '木曜日', active: false, is24hours: false, periods: [] },
        { label: '金曜日', active: false, is24hours: false, periods: [] },
        { label: '土曜日', active: false, is24hours: false, periods: [] },
        { label: '日曜日', active: false, is24hours: false, periods: [] },
      ],
      sidebarInfo: {
        sidebarList: [
          { label: 'ユーザー招待' },
          {
            label: '営業時間設定',
            subStepLabel: '営業時間設定する場合',
            steps: ['営業時間設定', '営業時間外対応方法設定', '休憩時間対応方法設定'],
            currentStep: 1,
          },
          { label: '着信フローの設定' },
        ],
        sidebarCurrent: 2,
        heading: '営業時間設定',
        subHeading: 'Step 2',
        sidebarSubHeading: 'Walk Through',
        sidebarHeading: '初期設定',
      },
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-walkthrough-business-hours-date-time');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    this.preloadData();
  },
  methods: {
    preloadData() {
      this.postRequest('/walkthrough/business-hours-date-time-preload-data', {
        companyID: this.companyID,
      })
        .then(res => {
          this.currentPeriodList = res.data;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
    handleSubmitForm(e) {
      e.preventDefault();
      const payload = cloneDeep(this.currentPeriodList);
      if (this.currentPeriodList.length !== 0) {
        this.handleSaveClick(payload);
      }
    },
    handleSaveClick() {
      for (let i = 0; i < 7; i++) {
        if (this.currentPeriodList[i].periods.length !== 0 && this.currentPeriodList[i].is24hours) {
          this.showErrorModal(messageContent.businessHoursConflictSetting);
          return;
        }
      }
      const formDataTmp = {
        companyID: this.selectedCompanyID,
        currentPeriodList: this.currentPeriodList,
      };
      //console.log('営業時間設定');
      //console.log(this.currentPeriodList);
      this.postRequest('/walkthrough/updatebusinesshours', formDataTmp)
        .then(e => {
          if (e.status === 'success') {
            // this.showInfoModal('営業時間設定が完了しました。');
            this.$router.push({ name: 'WTBusinessHoursGuidance' });
          } else if (e.status === 'duplicate') {
            this.showErrorModal(e.message);
          } else if (e.status === 'exceed') {
            this.showErrorModal(e.message);
          } else if (e.status === 'incorrect') {
            this.showErrorModal(e.message);
          } else {
            this.showErrorModal(messageContent.requireTry('設定変更'));
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('設定変更'));
        });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleFormSubmit(formData) {
      //console.log('営業時間設定');
      //console.log(formData);
    },
    handleCancelClick() {
      this.$router.push({ name: 'WTSelectBusinessHours' });
    },
    handleNotSettingClick() {
      this.updateFirstVisitFlag();
      this.$router.push({ name: 'Home' });
    },
    updateFirstVisitFlag(status = false) {
      this.postRequest('/walkthrough/update-firstVisitFlag', { status })
        .then(res => {
          if (res.status === 'success') {
            //console.log('firstVisitFlag is updated to', status);
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
  },
};
</script>
